import GeneratingUnitsStatusController from "./common/GeneratingUnitsStatusController";
import SystemInformationController from "./common/SystemInformationController";
import HydroElectricPowerPlantController from "./hydro/HydroElectricPowerPlantController";
import HydroVDIController from "./hydro/HydroVDIController";
import HydroElectricGeneratingUnitController from "./hydro/HydroElectricGeneratingUnitController";
import HydroElectricGeneratingUnitDiagnosticController from "./hydro/HydroElectricGeneratingUnitDiagnosticController";
import RegisterController from "./common/SignalRegistersController";
import EventSettingsController from "./common/EventSettingsController";
import EventRecordsController  from "./common/EventRecordsController";
import OilWhirlController from "./hydro/diagnostic/OilWhirlController";
import MagneticFluxController from "./hydro/diagnostic/MagneticFluxController";
import AirGapController from "./hydro/diagnostic/AirGapController";
import BladeDefectController from "./hydro/diagnostic/BladeDefectController";
import SensorSignalsController from "./hydro/diagnostic/SensorSignalsController";
import PressureFluctuationController from "./hydro/diagnostic/PressureFluctuationController";
import MisalignmentController from "./hydro/diagnostic/MisalignmentController";
import OverhungRotorController from "./hydro/diagnostic/OverhungRotorController";
import MaintenanceEventsController from "./wind//MaintenanceEventsController";
import TrendSignalsController from "./common/TrendSignalsController";
import TrendRecordsController from "./common/TrendRecordsController";
import AnomalyDetectionsController from "./common/AnomalyDetectionsController";
import AnomalyDetectionsKPIsController from "./common/AnomalyDetectionsKPIsController";
import AudioController from "./common/AudioController";
import UnbalanceContoller from "./hydro/diagnostic/UnbalanceContoller";
import LoosenessController from "./hydro/diagnostic/LoosenessController";
import BearingPadsDefectController from "./hydro/diagnostic/BearingPadsDefectController";
import RubbingController from "./hydro/diagnostic/RubbingController";
import StatorDefectController from "./hydro/diagnostic/StatorDefectController";
import WaveformChartDiagnosticController from "./wind/diagnostic/WaveformChartController";
import AuditLogController from "./common/AuditLogController";
import WindVDIController from "./wind/WindVDIController";
import OilController from "./wind/OilController";
import PitchTrendSignalRecordsController from "./wind/pitch/PitchTrendSignalRecordsController";
import PitchSignalRegistersController from "./wind/pitch/PitchSignalRegistersController";
import PitchSignalRecordsController from "./wind/pitch/PitchSignalRecordsController";
import UserController from "./common/UserController";
import UserPreferencesController from "./common/UserPreferencesController";
import ToolBarController from "./common/ToolBarController.js";
import CompaniesController from "./common/CompaniesController";
import FailSensorsController from "./common/FailSensorsController";
import WindParkController from "@/controllers/wind/WindParkController";
import WindTurbinesController from "@/controllers/wind/WindTurbinesController";
import WindTurbineStatusController from "@/controllers/wind/WindTurbineStatusController";
import ProtocolStatusController from "@/controllers/common/ProtocolStatusController";
import FrequencyComponentController from "@/controllers/common/FrequencyComponentController";
import SensorsController from "@/controllers/common/SensorsController";
import WindReportController from "@/controllers/wind/WindReportController";
import WindTurbinesDiagnosticSettingsV2Controller from "@/controllers/wind/diagnostic/WindTurbinesDiagnosticSettingsV2Controller";
import MainShaftAngularMisalignmentController from "@/controllers/wind/diagnostic/MainShaftAngularMisalignmentController";
import MainShaftAngularMisalignmentSignalsController from "@/controllers/wind/diagnostic/MainShaftAngularMisalignmentSignalsController";
import MainShaftParallelMisalignmentController from "@/controllers/wind/diagnostic/MainShaftParallelMisalignmentController";
import MainShaftParallelMisalignmentSignalsController from "@/controllers/wind/diagnostic/MainShaftParallelMisalignmentSignalsController";
import RollingBearingFailuresController from "@/controllers/wind/diagnostic/RollingBearingFailuresController";
import RollingBearingFailuresBearingController from "@/controllers/wind/diagnostic/RollingBearingFailuresBearingController";
import RollingBearingFailuresSignalsController from "@/controllers/wind/diagnostic/RollingBearingFailuresSignalsController";
import RollingBearingLoosenessController from "@/controllers/wind/diagnostic/RollingBearingLoosenessController";
import RollingBearingLoosenessSignalsController from "@/controllers/wind/diagnostic/RollingBearingLoosenessSignalsController";
import PlanetaryBrokenTeethController from "@/controllers/wind/diagnostic/PlanetaryBrokenTeethController";
import PlanetaryBrokenTeethSignalsController from "@/controllers/wind/diagnostic/PlanetaryBrokenTeethSignalsController";
import UnbalanceGeneratorShaftController from "@/controllers/wind/diagnostic/UnbalanceGeneratorShaftController";
import UnbalanceGeneratorShaftSignalsController from "@/controllers/wind/diagnostic/UnbalanceGeneratorShaftSignalsController";
import MainShaftUnbalanceController from "@/controllers/wind/diagnostic/MainShaftUnbalanceController";
import MainShaftUnbalanceSignalsController from "@/controllers/wind/diagnostic/MainShaftUnbalanceSignalsController";
import ElectricFailController from "@/controllers/wind/diagnostic/ElectricFailController";
import ElectricFailSignalsController from "@/controllers/wind/diagnostic/ElectricFailSignalsController";
import GearboxBrokenTeethController from "@/controllers/wind/diagnostic/GearboxBrokenTeethController";
import GearboxBrokenTeethSignalsController from "@/controllers/wind/diagnostic/GearboxBrokenTeethSignalsController";
import MisalingmentController from "./wind/diagnostic/MisalingmentController";
import AuditLogDiagnosticController from "@/controllers/common/AuditLogDiagnosticController";
import WindLimitsSettingsController from "@/controllers/wind/WindLimitSettingsController.js";
import WindCompanyTrendLimitsConfigurationsController from "@/controllers/wind/WindCompaniesTrendLimitsConfigurationsController";
import GeneratorShaftParallelMisalignmentController from "@/controllers/wind/diagnostic/GeneratorShaftParallelMisalignmentController";
import GeneratorShaftParallelMisalignmentSignalsController from "@/controllers/wind/diagnostic/GeneratorShaftParallelMisalignmentSignalsController";
import HydroCompaniesTrendLimitsConfigurationsController from "@/controllers/hydro/HydroCompaniesTrendLimitsConfigurationsController";
import HydroLimitSettingsController from "./hydro/HydroLimitSettingsController";
import FrequencyTrendSettingsController from "./common/FrequencyTrendSettingsController";
import FrequencyTrendLimitNotificationLogsController from "./common/FrequencyTrendLimitNotificationLogsController";
import FrequencyTrendLimitConfigurationsController from "./common/FrequencyTrendLimitConfigurationsController";
import BearingConfigurationController from "./wind/knowledge-base/BearingConfigurationController";
import GearboxConfigurationController from "./wind/knowledge-base/GearboxConfigurationController";
import TurbineConfigurationController from "./wind/knowledge-base/TurbineConfigurationController";
import TrendLineChartsController from "@/controllers/common/TrendLineChartsController";
import TrendScatterChartsController from "./common/TrendScatterChartsController";
import WindDiagnosticResultSetsController from "./wind/diagnostic/WindDiagnosticResultSetsController";
import NotificationLoggingController from "./common/NotificationLoggingsController";
import KinematicParametersController from "./wind/KinematicParametersController";

const HydroElectricPowerPlant = HydroElectricPowerPlantController;
const HydroElectricGeneratingUnit = HydroElectricGeneratingUnitController;
const HydroVDI = HydroVDIController;
const WindVDI = WindVDIController;
const FailSensors = FailSensorsController;
const SystemInformation = SystemInformationController;
const FrequencyComponent = FrequencyComponentController;
const HydroElectricGeneratingUnitDiagnostic = HydroElectricGeneratingUnitDiagnosticController;
const GeneratingUnitsStatus = GeneratingUnitsStatusController;
const SensorSignals = SensorSignalsController;
const MaintenanceEvent = MaintenanceEventsController;
const SignalsRegisters = RegisterController;
const EventSettings = EventSettingsController;
const EventRecords = EventRecordsController;
const TrendSettings = TrendSignalsController;
const TrendRecords = TrendRecordsController;
const AnomalyDetections = AnomalyDetectionsController;
const AnomalyDetectionsKPIs = AnomalyDetectionsKPIsController;
const WaveformChartDiagnostic = WaveformChartDiagnosticController;
const Audio = AudioController;
const OilWhirl = OilWhirlController;
const AirGap = AirGapController;
const OverhungRotor = OverhungRotorController;
const MagneticFlux = MagneticFluxController;
const BladeDefect = BladeDefectController;
const PressureFluctuation = PressureFluctuationController;
const Misalignment = MisalignmentController;
const Unbalance = UnbalanceContoller;
const Looseness = LoosenessController;
const BearingPadsDefect = BearingPadsDefectController;
const Rubbing = RubbingController;
const StatorDefect = StatorDefectController;
const AuditLog = AuditLogController;
const Oil = OilController;
const PitchTrendSignalRecords = PitchTrendSignalRecordsController;
const PitchSignalRegisters = PitchSignalRegistersController;
const PitchSignalRecords = PitchSignalRecordsController;
const Users = UserController;
const UsersPreferences = UserPreferencesController;
const ToolBar = ToolBarController;
const Companies = CompaniesController;
const WindParks = WindParkController;
const WindTurbines = WindTurbinesController;
const WindTurbineStatus = WindTurbineStatusController;
const Protocol = ProtocolStatusController;
const Sensors = SensorsController;
const WindReport = WindReportController;
const WindTurbinesDiagnosticSettingsV2 = WindTurbinesDiagnosticSettingsV2Controller;
const MainShaftAngularMisalignment = MainShaftAngularMisalignmentController;
const MainShaftAngularMisalignmentSignals = MainShaftAngularMisalignmentSignalsController;
const MainShaftParallelMisalignment = MainShaftParallelMisalignmentController;
const MainShaftParallelMisalignmentSignals = MainShaftParallelMisalignmentSignalsController;
const RollingBearingFailures = RollingBearingFailuresController;
const RollingBearingFailuresSignals = RollingBearingFailuresSignalsController;
const RollingBearingFailuresBearing = RollingBearingFailuresBearingController;
const RollingBearingLooseness = RollingBearingLoosenessController;
const RollingBearingLoosenessSignals = RollingBearingLoosenessSignalsController;
const PlanetaryBrokenTeeth = PlanetaryBrokenTeethController;
const PlanetaryBrokenTeethSignals = PlanetaryBrokenTeethSignalsController;
const UnbalanceGeneratorShaftSettings = UnbalanceGeneratorShaftController;
const UnbalanceGeneratorShaftSignals = UnbalanceGeneratorShaftSignalsController;
const MainShaftUnbalance = MainShaftUnbalanceController;
const MainShaftUnbalanceSignals = MainShaftUnbalanceSignalsController;
const ElectricFailSettings = ElectricFailController;
const ElectricFailSignals = ElectricFailSignalsController;
const GearboxBrokenTeeth = GearboxBrokenTeethController;
const GearboxBrokenTeethSignals = GearboxBrokenTeethSignalsController;
const Misalingment = MisalingmentController;
const AuditLogDiagnostic = AuditLogDiagnosticController;
const WindLimitsSettings = WindLimitsSettingsController;
const WindCompanyTrendLimitsConfigurations = WindCompanyTrendLimitsConfigurationsController;
const GeneratorShaftParallelMisalignment = GeneratorShaftParallelMisalignmentController;
const GeneratorShaftParallelMisalignmentSignals = GeneratorShaftParallelMisalignmentSignalsController;
const HydroCompaniesTrendLimitsConfigurations = HydroCompaniesTrendLimitsConfigurationsController;
const HydroLimitsSettings = HydroLimitSettingsController;
const FrequencyTrendSettings = FrequencyTrendSettingsController;
const FrequencyTrendLimitNotificationLogs = FrequencyTrendLimitNotificationLogsController;
const FrequencyTrendLimitConfigurations = FrequencyTrendLimitConfigurationsController;
const BearingConfiguration = BearingConfigurationController;
const GearboxConfiguration = GearboxConfigurationController;
const TurbineConfiguration = TurbineConfigurationController;
const TrendLineCharts = TrendLineChartsController;
const TrendScatterCharts = TrendScatterChartsController;
const WindDiagnosticResultSets = WindDiagnosticResultSetsController;
const NotificationLogging = NotificationLoggingController;
const KinematicParameters = KinematicParametersController;

export default {
	AnomalyDetections,
	AnomalyDetectionsKPIs,
	Audio,
	SystemInformation,
	AuditLog,
	BearingPadsDefect,
	BladeDefect,
	Companies,
	EventRecords,
	EventSettings,
	FrequencyComponent,
	GeneratingUnitsStatus,
	HydroElectricGeneratingUnit,
	HydroElectricGeneratingUnitDiagnostic,
	HydroElectricPowerPlant,
	WaveformChartDiagnostic,
	HydroVDI,
	Looseness,
	MaintenanceEvent,
	Misalignment,
	MagneticFlux,
	Oil,
	OilWhirl,
	AirGap,
	OverhungRotor,
	PressureFluctuation,
	PlanetaryBrokenTeeth,
	PlanetaryBrokenTeethSignals,
	RollingBearingLooseness,
	RollingBearingLoosenessSignals,
	Rubbing,
	SensorSignals,
	SignalsRegisters,
	WindTurbineStatus,
	StatorDefect,
	ToolBar,
	TrendRecords,
	TrendSettings,
	Unbalance,
	Users,
	UsersPreferences,
	FailSensors,
	Protocol,
	Sensors,
	WindParks,
	WindReport,
	WindTurbines,
	WindReport,
	PitchTrendSignalRecords,
	PitchSignalRegisters,
	PitchSignalRecords,
	WindTurbinesDiagnosticSettingsV2,
	MainShaftAngularMisalignment,
	MainShaftAngularMisalignmentSignals,
	MainShaftParallelMisalignment,
	MainShaftParallelMisalignmentSignals,
	RollingBearingFailures,
	RollingBearingFailuresBearing,
	RollingBearingFailuresSignals,
	UnbalanceGeneratorShaftSettings,
	UnbalanceGeneratorShaftSignals,
	MainShaftUnbalance,
	MainShaftUnbalanceSignals,
	WindVDI,
	ElectricFailSettings,
	ElectricFailSignals,
	GearboxBrokenTeeth,
	GearboxBrokenTeethSignals,
	Misalingment,
	AuditLogDiagnostic,
	WindLimitsSettings,
	WindCompanyTrendLimitsConfigurations,
	GeneratorShaftParallelMisalignment,
	GeneratorShaftParallelMisalignmentSignals,
	HydroCompaniesTrendLimitsConfigurations,
	HydroLimitsSettings,
	FrequencyTrendSettings,
	FrequencyTrendLimitNotificationLogs,
	FrequencyTrendLimitConfigurations,
	BearingConfiguration,
	GearboxConfiguration,
	TurbineConfiguration,
	TrendLineCharts,
	TrendScatterCharts,
	WindDiagnosticResultSets,
	NotificationLogging,
	KinematicParameters
};